import axios from "axios";

export const getVeicoliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + '/api/rfi/veicolo/', {
        params: params
    });
}

export const getCsvVeicoliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + '/api/rfi/veicolo/csv/', {
        params: params
    });
}

export const getVeicoloByIdApi = (idVeicolo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/${idVeicolo}`, {
        params: params
    });
}

export const deleteVeicoloApi = (idVeicolo, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/${idVeicolo}`, {
        params: params
    });
}

export const aggiungiVeicoloApi = (idUtente, payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/veicolo/`, payload, {
        params: params
    });
}

export const aggiornaVeicoloApi = (idVeicolo, idUtente, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/utente/${idUtente}/veicolo/${idVeicolo}`, payload, {
        params: params
    });
}

export const getCarrozzerieApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/carrozzeria/`, {
        params: params
    });
}

export const getColoriApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/colore/`, {
        params: params
    });
}

export const getColoreByIdApi = (idColore, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/colore/${idColore}`, {
        params: params
    });
}

export const aggiornaColoreApi = (idColore, payload, params = {}) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/colore/${idColore}`, payload, {
        params: params
    });
}

export const aggiungiColoreApi = (payload, params = {}) => {
    return axios.post(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/colore/`, payload, {
        params: params
    });
}

export const deleteColoreApi = (idColore, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/colore/${idColore}`, {
        params: params
    });
}

export const getMarcheApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/marca/`, {
        params: params
    });
}

export const getModelliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/modello/`, {
        params: params
    });
}

export const getRegistriVeicoliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/registro/`, {
        params: params
    });
}

export const getTipiDocumentoVeicoloApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/tipo-documento/`, {
        params: params
    });
}

export const getTipoCertificatoVeicoloApi = (idVeicolo, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/${idVeicolo}/tipo-certificato/`, {
        params: params
    });
}

export const getDocumentoVeicoloApi = (idVeicolo, idDocumento, params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/${idVeicolo}/documento/${idDocumento}`, {
        params: params
    });
}

export const eliminaDocumentoVeicoloApi = (idVeicolo, idDocumento, params = {}) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/veicolo/${idVeicolo}/documento/${idDocumento}`, {
        params: params
    });
}

export const getCruscottoVeicoliApi = (params = {}) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/rfi/cruscotto/`, {
        params: params
    });
}